import * as actions from "../actions";

const initialState = {
  form: null,
  redirectTo: null,
  redirectTriggered: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.CURRENT_FORM:
      return {
        ...state,
        form: action.payload.currentForm,
        licenceName: action.payload.licenceName
      }
    case actions.STORE_REDIRECT:
      return {
        ...state,
        redirectTo: action.payload.url,
        redirectTriggered: false,
      };
    case `${actions.REDIRECT_TRIGGER}_PENDING`:
      return {
        ...state,
        redirectTriggered: action.meta.trigger,
        redirectTo: !action.meta.trigger ? state.redirectTo : null
      };
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state
  }
}
